<template>
  <div class="email-preview-wrapper">
    <div class="email-preview-card">
      <div v-if="emailData?.subject" class="email-preview-subject">
        <strong>Subject:</strong> {{ emailData.subject }}
      </div>
      <div class="email-preview-body">
        <iframe
          v-if="isHtmlMode && emailData?.body"
          class="email-html-preview-frame"
          :srcdoc="previewSrcdoc"
          sandbox="allow-same-origin"
          title="Email content preview"
        ></iframe>
        <p v-else-if="emailData?.body" class="email-body-text">{{ emailData.body }}</p>
        <p v-else class="email-placeholder-text">Email body will appear here...</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmailPreview',
  props: {
    emailData: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    isHtmlMode() {
      return this.emailData?.editor_type === 'html';
    },
    previewSrcdoc() {
      if (!this.emailData?.body) return '';
      const body = this.emailData.body;
      // If it's already a full HTML document (has <html> or <!DOCTYPE>), use as-is
      if (body.trim().toLowerCase().startsWith('<!doctype') || body.trim().toLowerCase().startsWith('<html')) {
        return body;
      }
      // Otherwise wrap the fragment in a basic HTML shell for proper rendering
      return `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <style>
    body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; font-size: 14px; line-height: 1.6; color: #333; padding: 16px; margin: 0; }
    img { max-width: 100%; height: auto; }
    a { color: #6C63FF; }
  </style>
</head>
<body>${body}</body>
</html>`;
    },
  },
};
</script>

<style scoped lang="scss">
.email-preview-wrapper {
  padding: 8px 0;
}

.email-preview-card {
  border: 1px solid var(--vvd-color-neutral-200, #e0e0e0);
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.email-preview-subject {
  padding: 12px 16px;
  border-bottom: 1px solid var(--vvd-color-neutral-200, #e0e0e0);
  font-size: 14px;
  background: var(--vvd-color-neutral-50, #fafafa);
}

.email-preview-body {
  padding: 16px;
  min-height: 100px;
}

.email-html-preview-frame {
  width: 100%;
  min-height: 500px;
  border: none;
  background: #fff;
}

.email-body-text {
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-all;
  overflow-wrap: break-word;
  margin: 0;
}

.email-placeholder-text {
  font-size: 14px;
  color: var(--vvd-color-neutral-400, #9e9e9e);
  margin: 0;
}
</style>
